import {Icon} from '@wandb/weave/components/Icon';
import classNames from 'classnames';
import React, {ChangeEvent, FC, useCallback} from 'react';

import {
  usePanelSearchDebouncedContext,
  usePanelSearchInputContext,
} from '../../state/panelbank/PanelSearchContextProvider';

export const SearchInput: FC = () => {
  const {searchQuery, searchInputCallbackRef, onChangeSearchQuery} =
    usePanelSearchInputContext();
  const {isSearching} = usePanelSearchDebouncedContext();

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onChangeSearchQuery(e.target.value),
    [onChangeSearchQuery]
  );

  return (
    <div className={classNames('SearchInput', {isSearching})}>
      <Icon name="search" className="SearchIcon" />
      <input
        type="text"
        ref={searchInputCallbackRef}
        tabIndex={0}
        value={searchQuery}
        // data-test="panel-search-input"
        placeholder="Search keys with regex"
        aria-label="search keys with regex"
        onChange={onChange}
      />
    </div>
  );
};
